<template>
  <div>
    <div class="flex-col">
      <label for="first_name">
        {{ "register.form.first_name" | translate }}
      </label>
      <input
        type="text"
        name="first_name"
        id="first_name"
        v-model="input.firstName"
        class="form-input"
      />
      <label for="last_name">{{ "register.form.last_name" | translate }}</label>
      <input
        type="text"
        name="last_name"
        id="last_name"
        v-model="input.lastName"
        class="form-input"
      />
      <label for="email">{{ "register.form.email" | translate }}</label>
      <input
        type="email"
        name="email"
        id="email"
        v-model="input.email"
        class="form-input"
      />
      <span
        class="error"
        v-if="!field_validations.email && this.input.email.length > 3"
      >
        The email is invalid
      </span>
      <label for="password">{{ "register.form.password" | translate }}</label>
      <input
        type="password"
        name="password"
        id="password"
        v-model="input.password"
        class="form-input"
      />
      <label for="password_confirm">
        {{ "register.form.password_confirm" | translate }}
      </label>
      <input
        type="password"
        name="password"
        id="password_confirm"
        v-model="input.password_confirm"
        class="form-input"
      />
      <span class="error" v-if="!field_validations.password_confirm"
        >Passwords don't match</span
      >
      <div class="flex-col">
        <span>
          {{ "register.form.what_kind" | translate }}
          <span class="optional">
            {{ "register.form.optional" | translate }}
          </span>
        </span>
        <div class="flex">
          <input
            type="checkbox"
            class="checkbox"
            name="tags"
            value="female"
            v-model="input.tags"
            id="male_fashion"
          />
          <label for="male_fashion">
            {{ "register.form.female_fashion" | translate }}
          </label>
        </div>
        <div class="flex">
          <input
            type="checkbox"
            class="checkbox"
            name="tags"
            value="male"
            v-model="input.tags"
            id="female_fashion"
          />
          <label for="female_fashion">
            {{ "register.form.male_fashion" | translate }}
          </label>
        </div>
      </div>
      <div class="horizontal-line"></div>
      <div class="flex">
        <input
          type="checkbox"
          name="newsletter"
          id="newsletter"
          v-model="input.newsletter"
          class="checkbox"
          checked
        />
        <span class="circle-checkbox"></span>
        <label for="newsletter">
          {{ "register.form.newsletter" | translate }}
        </label>
      </div>
      <div class="flex">
        <input
          type="checkbox"
          name="privacy_policy"
          id="privacy_policy"
          v-model="input.privacy_policy"
          class="checkbox"
        />
        <label for="privacy_policy">
          {{ "register.form.privacy_policy" | translate }}
          <a class="text-gray-medium">
            {{ "register.form.terms" | translate }}
          </a>
          {{ "register.form.and" | translate }}
          <a class="text-gray-medium">
            {{ "register.form.privacy" | translate }}
          </a>
        </label>
      </div>

      <button
        class="button salmon"
        type="button"
        :disabled="!form_valid"
        v-on:click="register"
      >
        Register
      </button>
    </div>
  </div>
</template>

<script>
import { register } from "../services/api";
const field_validations = {
  firstName: firstName => !!firstName,
  lastName: lastName => !!lastName,
  email: email => !!email,
  password: password => !!password,
  password_confirm: (password_confirm, input) =>
    input.password === password_confirm,
  newsletter: () => true,
  privacy_policy: privacy_policy => !!privacy_policy
};
export default {
  name: "Register",
  data() {
    return {
      input: {
        firstName: null,
        lastName: null,
        email: "",
        password: null,
        password_confirm: null,
        newsletter: false,
        privacy_policy: null,
        tags: []
      },
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  computed: {
    field_validations() {
      const validators = {
        firstName: firstName => !!firstName,
        lastName: lastName => !!lastName,
        email: this.isEmailValid,
        password: password => !!password,
        password_confirm: (password_confirm, input) =>
          input.password === password_confirm,
        newsletter: () => true,
        privacy_policy: privacy_policy => !!privacy_policy
      };
      const results = Object.keys(validators).reduce((acc, key) => {
        const result =
          (validators[key] && validators[key](this.input[key], this.input)) ||
          !validators[key];
        return { ...acc, [key]: result };
      }, {});
      return results;
    },
    form_valid() {
      return Object.keys(this.input).every(key => {
        return (
          (field_validations[key] &&
            field_validations[key](this.input[key], this.input)) ||
          !field_validations[key]
        );
      });
    }
  },
  methods: {
    isEmailValid() {
      return this.input.email === ""
        ? true
        : this.reg.test(this.input.email)
        ? true
        : false;
    },
    async register(event) {
      event && event.preventDefault();
      const {
        firstName,
        lastName,
        email,
        password,
        newsletter,
        privacy_policy,
        tags
      } = this.input;
      const username = email;
      if (username != "" && password != "") {
        const user = {
          firstName,
          lastName,
          username,
          email,
          password,
          newsletter,
          privacy_policy,
          tags
        };
        const verify_route = "http://localhost:8080/verify_email";
        const res = await register(user, verify_route);
        if (!(res instanceof Error)) {
          this.$bvToast.toast("User created", {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
          this.$router.push({ name: "Login" });
        } else {
          // console.log(res);
          // console.log("A user with this email already exists");
        }
      } else {
        // console.log("A username and password must be present");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.flex {
  label {
    margin: 0;
  }

  margin-bottom: 1rem;
}

.flex-col {
  span {
    margin-bottom: 1rem;
  }
}

.button {
  box-shadow: none;
}

.horizontal-line {
  height: 2px;
  background-color: $brand-gray-light;
  width: 100%;
  margin: auto;
  margin-bottom: 2rem;
  max-width: 20rem;
  margin-top: 1rem;
}

.error {
  font-size: $font-xs;
  color: $brand-red;
}

.optional {
  color: $brand-gray-medium;
}
</style>
